<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="6" fill="#F5F5F5"/>
<g clip-path="url(#clip0_6670_66625)">
<path d="M10.6664 18.6661C9.93306 18.6661 9.33301 18.0661 9.33301 17.3327V10.6655C9.33301 9.93208 9.93306 9.33203 10.6664 9.33203H17.3336C18.067 9.33203 18.6671 9.93208 18.6671 10.6655M14.6668 13.3324H21.334C22.0704 13.3324 22.6674 13.9294 22.6674 14.6658V21.333C22.6674 22.0694 22.0704 22.6664 21.334 22.6664H14.6668C13.9303 22.6664 13.3333 22.0694 13.3333 21.333V14.6658C13.3333 13.9294 13.9303 13.3324 14.6668 13.3324Z" stroke="currentColor" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_6670_66625">
<rect width="16" height="16" fill="white" transform="translate(8 8)"/>
</clipPath>
</defs>
</svg>
